export function PAP_View_SignPage(properties) {
    return {
        class: 'sign_standalone',
        action: 'view',
        object: 'sign_page',
        properties,
    };
}
//# sourceMappingURL=view_sign_page.js.map